export class PrimaryContact {
    public email: string;
    public firstName: string;
    public lastName: string;
    public mobileNumber: string;
}
